import { createContext } from 'react';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var GradebookAppContext = /*#__PURE__*/createContext(null);